import type { GesCloudMember } from "./types/GesCloudUsersComponentTypes";

export const isOrganizationOwner = (members: GesCloudMember[], email: string | undefined) =>
	members.some((member) => member.type === "user" && member.isOwner && member.email === email);
